import { Base64 } from 'js-base64';
// 等待window[key]有值, 超过1s 就放弃
const waitWindowKey = (key: any) => {
  return new Promise((resolve, reject) => {
    const timer1 = setInterval(() => {
      if (window[key]) {
        clearInterval(timer1);
        resolve(window[key]);
      }
    }, 100);
    setTimeout(() => {
      clearInterval(timer1);
      resolve(null);
    }, 1000);
  });
};
// 编码得到数美header
const encode = (values: any) => {
  const { punishId, verifySdk = 1, timestamp, rid } = values || {};
  return punishId && rid ? Base64.encode(`${punishId};${verifySdk};${timestamp};${rid}`) : '';
};

const validate = async (securityContext: any) => {
  return await new Promise(async resolve => {
    const { verifyType = 1 } = securityContext || {};
    const initSMCaptcha: any = await waitWindowKey('initSMCaptcha');
    if (initSMCaptcha) {
      initSMCaptcha?.(
        {
          organization: 'qvdTr7A9k1DIU04ha4eP',
          product: 'popup',
          width: 255,
          mode: ['', 'slide', 'select'][verifyType] || 'slide',
        },
        (SMCaptcha: any) => {
          // 校验回调
          SMCaptcha.onSuccess((data: any) => {
            const { rid, pass } = data || {};
            if (rid && pass) {
              resolve({
                'X-Mcd-Sec-Verify': encode({
                  ...securityContext,
                  ...data,
                  timestamp: Date.now(),
                }),
              });
            }
          });
          SMCaptcha.onClose(() => {
            console.log('SM弹窗关闭');
            resolve(null);
          });
          // 资源加载异常
          SMCaptcha.onError(() => {
            console.log('SM资源加载异常');
            resolve(null);
          });

          SMCaptcha.onReady(function (rootEl: any, params: any) {
            // params.type init:启动后  refresh:-手动刷新图片后  afterFail:-验证失败后
            // 初始化成功后，自动弹开
            if (params?.type === 'init') SMCaptcha.verify();
          });
        },
      );
    } else {
      resolve(null);
    }
  });
};

const sendWithSM = async (send: any, url: string, options: any) =>
  new Promise(async (resolve, reject) => {
    let res: any = null;
    try {
      res = await send(url, options);
      console.log(res);
      // 需要数美验证
      if (res?.code === 420) {
        const smHeader = await validate(res?.data?.securityContext);
        if (smHeader) {
          res = await send(url, {
            ...options,
            headers: {
              ...options?.headers,
              ...smHeader,
            },
          });
        }
      }
    } catch (error) {
      console.log(error);
      reject(error);
    }
    resolve(res);
  });

export default sendWithSM;  
